export const trDict = {
  'Account recovery requires verified contact information':
    'Hesap kurtarma, doğrulanmış iletişim bilgilerini gerektirir',
  'An account with the given email already exists.':
    'Bu e-postaya ait zaten bir hesap var.',
  'Back to Sign In': 'Oturum Açmaya Geri Dön',
  'Change Password': 'Şifreyi Değiştir',
  Changing: 'Değiştiriliyor',
  Code: 'Kod',
  Confirm: 'Doğrula',
  'Confirm Password': 'Şifreyi Doğrula',
  'Confirm Sign In': 'Oturum Açmayı Doğrula',
  'Confirm Sign Up': 'Kayıt İşlemini Doğrula',
  'Confirm SMS Code': 'SMS Kodunu Doğrula',
  'Confirm TOTP Code': 'Tek Kullanımlık Şifreyi Doğrula',
  'Confirmation Code': 'Doğrulama Kodu',
  Confirming: 'Doğrulanıyor',
  'Create Account': 'Hesap Oluştur',
  'Creating Account': 'Hesap Oluşturuluyor',
  Email: 'E-posta',
  'Enter your code': 'Kodu girin',
  'Enter your username': 'Kullanıcı adınızı girin',
  'Enter your phone number': 'Telefon numaranızı girin',
  'Enter your email': 'E-posta adresinizi girin',
  'Forgot your password?': 'Şifrenizi mi unuttunuz?',
  'Hide password': 'Şifreyi gizle',
  'Have an account? ': 'Hesabınız var mı? ',
  'Incorrect username or password': 'Yanlış kullanıcı adı ya da şifre',
  'Invalid password format': 'Geçersiz parola formatı',
  'Invalid phone number format': 'Geçersiz telefon numarası formatı',
  'Lost your code? ': 'Kodu mu kaybettiniz? ',
  Loading: 'Yükleniyor',
  'New password': 'Yeni şifre',
  'No account? ': 'Hesabınız yok mu? ',
  or: 'veya',
  Password: 'Şifre',
  'Password attempts exceeded': 'Maksimum oturum açma girişimi aşıldı',
  'Phone Number': 'Telefon Numarası',
  'Resend Code': 'Kodu Yeniden Gönder',
  'Reset your password': 'Şifrenizi sıfırlayın',
  'Reset your Password': 'Şifrenizi Sıfırlayın',
  'Send Code': 'Kod Gönder',
  'Send code': 'Kod gönder',
  Sending: 'Gönderiliyor',
  'Setup TOTP': 'Tek kullanımlık şifre kurulumu yap',
  'Show password': 'Şifreyi göster',
  'Sign in': 'Oturum aç',
  'Sign In': 'Oturum Aç',
  'Sign In with Amazon': 'Amazon ile Oturum Aç',
  'Sign In with Apple': 'Apple ile Oturum Aç',
  'Sign In with Facebook': 'Facebook ile Oturum Aç',
  'Sign In with Google': 'Google ile Oturum Aç',
  'Sign in to your account': 'Hesabınızda oturum açın',
  'Create a new account': 'Yeni bir hesap oluştur',
  'Signing in': 'Oturum açılıyor',
  'Sign Out': 'Çıkış yap',
  'Sign Up': 'Kayıt Ol',
  Skip: 'Atla',
  Submit: 'Gönder',
  Submitting: 'Gönderiliyor',
  'User already exists': 'Bu kullanıcı zaten var',
  'User does not exist': 'Böyle bir kullanıcı mevcut değil',
  Username: 'Kullanıcı adı',
  'Username cannot be empty': 'Kullanıcı adı boş olamaz',
  'Verify Contact': 'Kişiyi Doğrula',
  Verify: 'Doğrula',
};
